import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReduxStore from '@mgc/map-client-shared/lib/ReduxStore';
import { mapSelectors } from '@mgc/map-client-shared/lib/ReduxTools';
import moment from 'moment';
import MapPropTypes from './MapPropTypes';
import selectors from '../selectors';
import strings from '../strings';
import utils from '../utils';

class PrintableTransactions extends Component {
    static propTypes = {
        offer: MapPropTypes.OfferProps,
        transaction: MapPropTypes.TransactionProps,
        serverAliases: PropTypes.object,
    };

    static mapState = (state) =>
        mapSelectors(state, {
            offer: selectors.offer.getSelectedOffer,
            transaction: selectors.order.getLastTransaction,
            serverAliases: selectors.user.getServerAliases,
        });

    _getLicenseDuration(license) {
        if (this.props.offer && this.props.offer.dailyPricingEnabled) {
            return Math.max(
                0,
                moment(license.validTo)
                    .startOf('day')
                    .diff(moment(license.validFrom).startOf('day'), 'days')
            );
        }

        return license.duration;
    }

    _renderBody() {
        if (this.props.transaction.licenses) {
            return (
                <tbody>
                    {this.props.transaction.licenses.map((license, i) => {
                        const serverAlias = this.props.serverAliases[
                            license.server.id
                        ] ? (
                            <span className="text-muted">
                                ({strings.alias}:{' '}
                                {this.props.serverAliases[license.server.id]})
                            </span>
                        ) : null;

                        return (
                            <tr key={i}>
                                <td>{license.product.mentorId}</td>
                                <td>{license.product.name}</td>
                                <td>{license.site.mentorId}</td>
                                <td>
                                    {license.server.mentorId} {serverAlias}
                                </td>
                                <td>{license.seats}</td>
                                <td>{this._getLicenseDuration(license)}</td>
                                <td>{utils.formatShortDate(license.validTo)}</td>                                
                                {this.props.offer.weeklyPricingEnabled && (
                                    <td>{license.weeks}</td>
                                )}
                                <td>{utils.formatPrice(license.amount)}</td>
                            </tr>
                        );
                    })}
                </tbody>
            );
        }
    }

    _renderLicenseTable() {
        return (
            <table className="table table-sm table-bordered table-striped">
                <thead>
                    <tr>
                        <th>{strings.partNumber}</th>
                        <th>{strings.product}</th>
                        <th>{strings.site}</th>
                        <th>{strings.server}</th>
                        <th>{strings.seats}</th>
                        <th>
                            {this.props.offer &&
                            this.props.offer.dailyPricingEnabled
                                ? strings.days
                                : strings.months}
                        </th>
                        <th>{strings.endDate}</th>
                        {this.props.offer.weeklyPricingEnabled && (
                            <th>{strings.weeks}</th>
                        )}
                        <th>{strings.subtotal}</th>
                    </tr>
                </thead>
                {this._renderBody()}
            </table>
        );
    }

    render() {
        if (!this.props.transaction) {
            return null;
        }

        const dt = (s) => <dt className="col-xs-3 m-a-0">{s}</dt>;
        const dd = (s) => <dd className="col-xs-9 m-a-0">{s}</dd>;

        return (
            <div>
                <h1 className="m-b-md">{strings.printHeader}</h1>
                <div className="m-b-md">
                    <dl className="dl-horizontal">
                        {dt(strings.orderDate)}
                        {dd(
                            utils.formatDate(
                                moment(this.props.transaction.lastModified)
                            )
                        )}
                        {dt(strings.username)}
                        {dd(this.props.transaction.user.email)}
                        {dt(strings.confirmation)}
                        {dd(this.props.transaction.confirmation)}                        
                        {/* dt(strings.specialInstructions) */}
                        {/* dd(this.props.transaction.instructions || strings.none) */}
                    </dl>
                </div>
                {this._renderLicenseTable()}
                <div className="pull-right text-xxl">
                    <strong>{strings.total}</strong>:{' '}
                    {this.props.transaction.amount}&nbsp;
                    {this.props.transaction.currency || ''}
                </div>
            </div>
        );
    }
}

export default ReduxStore.attach(PrintableTransactions);



// WEBPACK FOOTER //
// ./app/components/PrintableTransaction.jsx